export enum GroupName {
	BENEFICIARIO = 'beneficiario',
	OPERADOR = 'operador',
	SUPER_USER = 'super',
}
